/**
 * 変更履歴アイコンコンポーネント
 * グローバルメニューに配置し、クリックで履歴パネルを開く
 */

import React from 'react';
import { IconButton, Badge, Tooltip } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { useChangeManager } from '../context/ChangeManagerContext';

interface ChangeHistoryIconProps {
  color?: any;
  size?: 'small' | 'medium' | 'large';
}

/**
 * 変更履歴アイコン
 * バッジで未読数を表示
 */
export function ChangeHistoryIcon({ color = 'inherit', size = 'medium' }: ChangeHistoryIconProps): React.ReactElement {
  const { toggleHistoryPanel, unreadCount, history } = useChangeManager() as any;

  return (
    <Tooltip title={`変更履歴 (${history.length}件)`}>
      <IconButton
        color={color}
        size={size}
        onClick={toggleHistoryPanel}
        aria-label="変更履歴を開く"
      >
        <Badge
          badgeContent={unreadCount}
          color="error"
          max={99}
          invisible={unreadCount === 0}
        >
          <HistoryIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}

export default ChangeHistoryIcon;
